import {
  OuiBoxComponent,
  OuiDividerComponent,
  OuiRowComponent,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-page',
  imports: [
    OuiStackComponent,
    OuiRowComponent,
    OuiBoxComponent,
    OuiTextComponent,
    OuiDividerComponent,
  ],
  templateUrl: './page.html',
  standalone: true,
})
export class PageComponent {
  headline = input<string>('');
}
